import OnboardingAsset, {
  IOnboardingAsset,
  IOnboardingAssetApi,
} from './OnboardingAsset.model';

export interface IPaginationResultGroups<T> {
  totalPages: number;
  totalAssets: number;
  assetsPerPage: number;
  currentPage: number;
  isLastPage: boolean;
  assets: T[];
}

export type MfrErrors =
  | 'Manufacturer Not Found'
  | 'Manufacturer field is Empty';
export type MpnErrors =
  | 'Model Number Not Found'
  | 'Model Number field is Empty'
  | 'Manufacturer Part Number is Invalid';
export type ProductNameErrors =
  | 'Product Name Not Found'
  | 'Product Name field is Empty';

export interface IOnboardingGroup {
  id: string;
  items: IOnboardingAsset[];
  count: number;
  model: string;
  manufacturer: string;
  productName: string;
  mpnError: MpnErrors | null;
  mfrError: MfrErrors | null;
  mfrSuggestions: [];
  productNameError: ProductNameErrors | null;
  isNotAccessory: boolean;
  accessoryError: string | null;
  isManufacturerAccessory: boolean;
  accessoryKeyword: string[];
}

export interface IOnboardingGroupApi {
  _id: string;
  items: IOnboardingAssetApi[];
  count: number;
  mpn: string;
  mfr: string;
  productName: string;
  mpnError: MpnErrors | null;
  mfrError: MfrErrors | null;
  mfrSuggestions: [];
  productNameError: ProductNameErrors | null;
  isNotAccessory: boolean;
  accessoryError: string | null;
  isManufacturerAccessory: boolean;
  accessoryKeyword: string[];
}

export default class Tag implements IOnboardingGroup {
  public readonly id: string;

  public readonly items: IOnboardingAsset[];

  public readonly count: number;

  public readonly model: string;

  public readonly manufacturer: string;

  public readonly productName: string;

  public readonly mpnError: MpnErrors | null;

  public readonly mfrError: MfrErrors | null;

  public readonly mfrSuggestions: [];

  public readonly productNameError: ProductNameErrors | null;

  public readonly isNotAccessory: boolean;

  public readonly accessoryError: string | null;

  public readonly isManufacturerAccessory: boolean;

  public readonly accessoryKeyword: string[];

  constructor(
    id: string,
    items: IOnboardingAsset[],
    count: number,
    model: string,
    manufacturer: string,
    productName: string,
    mpnError: MpnErrors | null,
    mfrError: MfrErrors | null,
    mfrSuggestions: [],
    productNameError: ProductNameErrors | null,
    isNotAccessory: boolean,
    accessoryError: string | null,
    isManufacturerAccessory: boolean,
    accessoryKeyword: string[],
  ) {
    this.id = id;
    this.items = items;
    this.count = count;
    this.model = model;
    this.manufacturer = manufacturer;
    this.productName = productName;
    this.mpnError = mpnError;
    this.mfrError = mfrError;
    this.mfrSuggestions = mfrSuggestions;
    this.productNameError = productNameError;
    this.isNotAccessory = isNotAccessory;
    this.accessoryError = accessoryError;
    this.isManufacturerAccessory = isManufacturerAccessory;
    this.accessoryKeyword = accessoryKeyword;
  }

  static fromApiModel(apiModel: IOnboardingGroupApi) {
    const {
      _id,
      count,
      mfr,
      mfrError,
      mfrSuggestions,
      mpn,
      mpnError,
      productName,
      productNameError,
      accessoryError,
      isNotAccessory,
      isManufacturerAccessory,
      accessoryKeyword,
    } = apiModel;

    const items = OnboardingAsset.arrayFromApiModel(apiModel.items);

    return new Tag(
      _id,
      items,
      count,
      mpn,
      mfr,
      productName,
      mpnError,
      mfrError,
      mfrSuggestions,
      productNameError,
      isNotAccessory,
      accessoryError,
      isManufacturerAccessory,
      accessoryKeyword,
    );
  }

  static arrayFromApiModel(arrayApiModel: IOnboardingGroupApi[]) {
    const array = arrayApiModel.map(apiModel => this.fromApiModel(apiModel));

    return array;
  }

  static arrayPaginatedFromApiModel(
    arrayApiModel: IPaginationResultGroups<IOnboardingGroupApi>,
  ) {
    const array = this.arrayFromApiModel(arrayApiModel.assets);

    return {
      ...arrayApiModel,
      assets: array,
    };
  }
}
